const invalidEmailParts = [
  '@yahoo.',
  '@gmail.',
  '@hotmail.',
  '@outlook.',
  '@live.',
  '@icloud.',
  '@mail.',
  '@seznam.',
  '@wp.',
  '@yandex.',
  '@qq.',
  '@proton.',
  '@aol.',
  '@msn.',
  '@gmx.',
  '@help.',
  '@etc.',
  '@leo.',
  '@leogmail.',
  '@gucci.',
]

type ValidationOptions = {
  disallowEmpty?: boolean
}

function isInvalidWorkEmail(
  email: string,
  { disallowEmpty = false }: ValidationOptions,
) {
  if (disallowEmpty && !email) {
    return true
  }
  const emailToCheck = email.toLowerCase()
  return invalidEmailParts.some(invalidPart =>
    emailToCheck.includes(invalidPart),
  )
}

export function validateWorkEmailInput(
  element: HTMLInputElement,
  opts: ValidationOptions = {},
) {
  if (isInvalidWorkEmail(element.value, opts)) {
    element.setCustomValidity('Please provide the email you use at work.')
    element.reportValidity()
    return false
  } else {
    element.setCustomValidity('')
    return true
  }
}
